module.exports = __webpack_public_path__ + "img/electronics-icon.16cf791fd17b9379c2f43d224432490e.svg";